import { render } from "./ExternalSignDocumentInfo.vue?vue&type=template&id=2561eb76&scoped=true"
import script from "./ExternalSignDocumentInfo.vue?vue&type=script&lang=js"
export * from "./ExternalSignDocumentInfo.vue?vue&type=script&lang=js"

import "./ExternalSignDocumentInfo.vue?vue&type=style&index=0&id=2561eb76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2561eb76"]])

export default __exports__